var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { COLOR } from '../theme/colors';
import React, { useCallback } from 'react';
import { AppSearchBar } from './SearchBar.styled';
import IconButton from '@mui/material/IconButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import TextField from '../TextField';
import Typography from '../Typography';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { AdvanceSearch, AdvanceSearchBlue, CloseIcon } from '../Icon';
import makeStyles from '@mui/styles/makeStyles';
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import { isEmpty } from 'lodash';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateRangePicker } from '../DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Button from '../Button';
import get from 'lodash/get';
import { DashboardTooltip } from '../OverflowTip';
import { styled } from "@mui/material/styles";
import Divider from '@mui/material/Divider';
const useStyles = makeStyles(() => ({
    parent: {
        position: 'relative',
    },
    textField: {
        width: 328,
    },
    btnSearchSmall: {
        margin: -1,
    },
    btnSearchMedium: {
        margin: 1,
        marginRight: 5,
        padding: '3px !important',
    },
    iconSearchSmall: {
        fontSize: 20,
    },
    iconSearchMedium: {
        fontSize: 30,
    },
    btnDeleteSmall: {
        margin: -1,
        // padding: '3px !important',
        borderRadius: '4px !important',
        width: 32,
        height: 32
    },
    btnDeleteMedium: {
        margin: 1,
        // padding: '4px !important',
        borderRadius: '4px !important',
        width: 32,
        height: 32
    },
    iconDeleteSmall: {
        fontSize: 20,
    },
    iconDeleteMedium: {
        fontSize: 25,
    },
    advancePopover: {
        borderRadius: 8,
        padding: 24,
        width: 432
    }
}));
function invColor(variant = 'contained') {
    if (variant === 'contained')
        return COLOR.commonColor.white;
    else
        return COLOR.commonColor.primary;
}
const CustomToggleButton = styled(ToggleButton)({
    "&.MuiToggleButton-root": {
        padding: '0px !important',
        border: 'none !important'
    },
    "&.MuiToggleButton-root:hover": {
        backgroundColor: '#33333314'
    },
    "&.Mui-selected, &.Mui-selected:hover": {
        color: "white",
        backgroundColor: '#3333331F'
    },
    "& .MuiTouchRipple-root .MuiTouchRipple-child": {
        borderRadius: "4px",
        backgroundColor: '#3333331F'
    }
});
export const SearchBar = (props) => {
    const { size = 'medium', searchOnTyping = false, searchOnClearInput = false, searchOnEnter = true, parentStyle = {}, defaultValue = '', advanceArray = null, width = 328, displayAdvanced = false, } = props;
    const [searchString, setSearchString] = React.useState(defaultValue);
    const [searchStringAdvance, setSearchStringAdvance] = React.useState(defaultValue);
    const [searchStringAdvanceBackup, setSearchStringAdvanceBackup] = React.useState(defaultValue);
    const [displayAdvance, setDisplayAdvance] = React.useState(false);
    const [toggleValue, setToggleValue] = React.useState('');
    const [forceShow, setForceShow] = React.useState(false);
    const [searchValue, setSearchValue] = React.useState({});
    const [anchorEl, setAnchorEl] = React.useState(null);
    const objRef = React.useRef();
    const showAdvance = !isEmpty(advanceArray);
    const clearSearchString = () => {
        setSearchString('');
        if (!isEmpty(advanceArray)) {
            setSearchStringAdvance('');
            setSearchStringAdvanceBackup('');
        }
        if (searchOnClearInput) {
            if (props.onSearch) {
                props.onSearch('');
            }
        }
    };
    const includesKey = (str) => {
        if (str.includes("email:") || str.includes("service:") || str.includes("start:") || str.includes("end:")) {
            return true;
        }
        else {
            return false;
        }
    };
    const buildSearchInfo = () => {
        let searchV = {};
        if (includesKey(searchString)) {
            //split by space
            const split = searchString.match(/(?:[^\s"]+|"[^"]*")+/g);
            if (split && split.length > 0) {
                split.forEach(s => {
                    const filter = s.split(':');
                    if (filter.length > 1) { // has condition
                        let value = filter[1];
                        if (filter.length > 2) {
                            // combine all
                            let combine = '';
                            for (let i = 1; i < filter.length; i++) {
                                if (i === filter.length - 1) {
                                    combine += filter[i];
                                }
                                else {
                                    combine += filter[i] + ":";
                                }
                            }
                            value = combine;
                        }
                        switch (filter[0]) {
                            case 'email':
                                // remove "" if exist, trim space
                                // eslint-disable-next-line no-case-declarations
                                let temp = value;
                                if (temp.length > 0) {
                                    if (temp[0] === '"' && temp[temp.length - 1] === '"') {
                                        temp = temp.slice(1, temp.length - 1);
                                    }
                                }
                                searchV['email'] = temp;
                                break;
                            case 'service':
                                // remove "" if exist, trim space
                                // eslint-disable-next-line no-case-declarations
                                let temp1 = value;
                                if (temp1.length > 0) {
                                    if (temp1[0] === '"' && temp1[temp1.length - 1] === '"') {
                                        temp1 = temp1.slice(1, temp1.length - 1);
                                    }
                                }
                                searchV['service'] = temp1;
                                break;
                            case 'start':
                                {
                                    if (dayjs(value, 'MM-DD-YYYY').isValid()) {
                                        searchV['start'] = value;
                                    }
                                    else {
                                        searchV['start'] = null;
                                    }
                                }
                                break;
                            case 'end':
                                {
                                    if (dayjs(value, 'MM-DD-YYYY').isValid()) {
                                        searchV['end'] = value;
                                    }
                                    else {
                                        searchV['end'] = null;
                                    }
                                }
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        }
        else {
            searchV['email'] = searchString;
            setSearchString(searchString);
        }
        setSearchValue(searchV);
    };
    const openAdvance = () => {
        setToggleValue('advancedSearch');
        // parse from searchstring
        // start:11/11/2024 end:11/11/2024 email:email service:"ser vice"
        // clear all data
        setSearchValue({});
        buildSearchInfo();
        setDisplayAdvance(true);
        setAnchorEl(objRef.current);
    };
    if (forceShow !== displayAdvanced) {
        setDisplayAdvance(true);
        setAnchorEl(objRef.current);
        setForceShow(displayAdvanced);
        openAdvance();
    }
    const handleKeywordChange = (e) => {
        setSearchString(e.target.value);
        if (searchOnTyping) {
            if (props.onSearch) {
                props.onSearch(e.target.value);
            }
        }
    };
    const hasSearchString = () => {
        return searchString.length > 0;
    };
    const handleKeyPress = (e) => {
        if (searchOnEnter) {
            if (e.keyCode === 13) {
                if (props.onSearch) {
                    props.onSearch(searchString);
                }
            }
        }
    };
    const handleKeyPressAdvanced = (e) => {
        if (searchOnEnter) {
            if (e.keyCode === 13) {
                handleAdvanceSearch();
            }
        }
    };
    const classes = useStyles();
    let btnSearchStyle = classes.btnSearchSmall;
    let iconSearchStyle = classes.iconSearchSmall;
    let btnDeleteStyle = `${classes.btnDeleteSmall} clearSearch`;
    let iconDeleteStyle = classes.iconDeleteSmall;
    if (size === 'medium') {
        btnSearchStyle = classes.btnSearchMedium;
        iconSearchStyle = classes.iconSearchMedium;
        btnDeleteStyle = `${classes.btnDeleteMedium} clearSearch`;
        iconDeleteStyle = classes.iconDeleteMedium;
    }
    const onPopoverClose = (e, reason) => __awaiter(void 0, void 0, void 0, function* () {
        setDisplayAdvance(false);
        setToggleValue('');
        setAnchorEl(null);
        //rollback advance search string
        if (searchString !== '') {
            setSearchStringAdvance(searchStringAdvanceBackup);
        }
        else {
            setSearchValue({});
            setSearchStringAdvance('');
        }
    });
    const onChangeValue = (e) => {
        let search = searchValue;
        search[`${e.target.id}`] = e.target.value;
        setSearchValue(search);
        buildSearchString();
    };
    const setStartValue = (value) => {
        let search = searchValue;
        search['start'] = dayjs(value).valueOf();
        const end = get(searchValue, 'end', 0);
        search['time'] = [dayjs(value).valueOf(), end];
        setSearchValue(search);
        buildSearchString();
    };
    const setEndValue = (value) => {
        let search = searchValue;
        search['end'] = dayjs(value).valueOf();
        const start = get(searchValue, 'start', 0);
        search['time'] = [start, dayjs(value).valueOf(),];
        setSearchValue(search);
        buildSearchString();
    };
    const handleOnReset = useCallback(() => {
        setSearchValue({});
        setSearchStringAdvance('');
    }, []);
    const buildSearchString = () => {
        //build advance search string
        let searchString = '';
        if (!isEmpty(searchValue)) {
            searchString = '';
            for (const property in searchValue) {
                if (property === 'time') { //ignore
                }
                else if (property === 'start') {
                    //check valid -> fail -> ignore
                    if (dayjs(searchValue[property]).isValid()) {
                        searchString += property + ':' + dayjs(searchValue[property]).format('MM/DD/YYYY');
                        searchString += ' ';
                    }
                }
                else if (property === 'end') {
                    if (dayjs(searchValue[property]).isValid()) {
                        searchString += property + ':' + dayjs(searchValue[property]).format('MM/DD/YYYY');
                        searchString += ' ';
                    }
                }
                else {
                    if (searchValue[property].length > 0) {
                        // incase: include space inside -> user ""
                        if (searchValue[property].indexOf(' ') >= 0) {
                            searchString += property + ':"' + searchValue[property] + '"';
                        }
                        else {
                            searchString += property + ':' + searchValue[property];
                        }
                        searchString += ' ';
                    }
                }
            }
            //remove lase |
            searchString = searchString.slice(0, -1);
        }
        setSearchStringAdvance(searchString);
        setSearchStringAdvanceBackup(searchString);
        return searchString;
    };
    const handleAdvanceSearch = () => {
        if (!isEmpty(advanceArray)) {
            const str = buildSearchString();
            setSearchString(str);
            if (props.onSearch) {
                props.onSearch(str);
            }
        }
        else {
            if (props.onSearch) {
                props.onSearch(searchString);
            }
        }
        //close popover
        setDisplayAdvance(false);
        setToggleValue('');
        setAnchorEl(null);
    };
    const handleDateChange = (value) => {
        setStartValue(value[0]);
        setEndValue(value[1]);
    };
    const AdvancePopover = () => {
        const startValid = dayjs(get(searchValue, 'start', null)).isValid();
        const endValid = dayjs(get(searchValue, 'end', null)).isValid();
        const startValue = startValid ? dayjs(get(searchValue, 'start', null)).toDate() : null;
        const endValue = endValid ? dayjs(get(searchValue, 'end', null)).toDate() : null;
        if (showAdvance) {
            return (_jsxs(Box, Object.assign({ style: { display: 'contents' } }, { children: [advanceArray.map(obj => {
                        switch (obj.type) {
                            case 'textfield':
                                return (_jsxs(Box, Object.assign({ mb: 2 }, { children: [_jsx(Box, Object.assign({ mb: 1 }, { children: _jsx(Typography, Object.assign({ variant: 'subtitle2' }, { children: `${obj.label} ` })) })), _jsx(TextField, { placeholder: obj.placeholder, value: get(searchValue, `${obj.id}`, ''), fullWidth: true, label: '', id: `${obj.id}`, style: { height: 40 }, onChange: onChangeValue, onKeyDown: handleKeyPressAdvanced })] })));
                            case 'datepicker':
                                return (_jsxs(Box, Object.assign({ mb: 2 }, { children: [_jsxs(Box, Object.assign({ mb: 1, style: { display: 'flex' } }, { children: [_jsx(Box, Object.assign({ style: { marginRight: 4, width: '50%' } }, { children: _jsx(Typography, Object.assign({ variant: 'subtitle2' }, { children: `${obj.label1} ` })) })), _jsx(Box, Object.assign({ style: { marginLeft: 4, width: '50%' } }, { children: _jsx(Typography, Object.assign({ variant: 'subtitle2' }, { children: `${obj.label2} ` })) }))] })), _jsx(Box, Object.assign({ style: { display: 'flex' } }, { children: _jsx(DateRangePicker, { onChange: handleDateChange, value: [startValue, endValue] }) }))] })));
                            default: //textfield
                                return (_jsxs(Box, Object.assign({ mb: 2 }, { children: [_jsx(Box, Object.assign({ mb: 1 }, { children: _jsx(Typography, Object.assign({ variant: 'subtitle2', color: 'textSecondary' }, { children: "User name" })) })), _jsx(TextField, { fullWidth: true, label: `${obj.label} `, id: `${obj.id} `, style: { height: 40 }, onChange: onChangeValue })] })));
                        }
                    }), _jsx(Box, Object.assign({ mt: 3, ml: -3, mr: -3 }, { children: _jsx(Divider, { style: { backgroundColor: COLOR.primaryGreyScale[8104] } }) })), _jsxs(Box, Object.assign({ style: { display: 'flex', justifyContent: 'flex-end', paddingTop: 24 } }, { children: [_jsx(Button, Object.assign({ variant: 'text', onClick: handleOnReset, style: { marginRight: 8 } }, { children: "RESET" })), _jsx(Button, Object.assign({ variant: 'contained', onClick: handleAdvanceSearch }, { children: "SEARCH" }))] }))] })));
        }
        else {
            return _jsx(_Fragment, {});
        }
    };
    const EndAdorament = () => {
        if (showAdvance) {
            return (hasSearchString() ? (_jsxs(_Fragment, { children: [_jsx(InputAdornment, Object.assign({ position: "end" }, { children: _jsx(DashboardTooltip, Object.assign({ title: 'Clear search', placement: "bottom", arrow: true }, { children: _jsx(IconButton, Object.assign({ className: btnDeleteStyle, onClick: clearSearchString, size: "small", sx: {
                                    "& .MuiTouchRipple-root .MuiTouchRipple-child": {
                                        borderRadius: "4px",
                                        backgroundColor: '#3333331F'
                                    }
                                } }, { children: _jsx(CloseIcon, { className: iconDeleteStyle }) })) })) })), _jsx(InputAdornment, Object.assign({ position: "end", sx: { marginLeft: '0px' } }, { children: _jsx(DashboardTooltip, Object.assign({ title: 'Open advanced search', placement: "bottom", arrow: true }, { children: _jsx(ToggleButtonGroup, Object.assign({ color: "primary", value: toggleValue, exclusive: true }, { children: _jsx(CustomToggleButton, Object.assign({ value: "advancedSearch", onClick: openAdvance }, { children: searchStringAdvance !== '' ? (_jsx(AdvanceSearchBlue, { className: iconDeleteStyle })) : (_jsx(AdvanceSearch, { className: iconDeleteStyle })) })) })) })) }))] })) : (_jsx(InputAdornment, Object.assign({ position: "end" }, { children: _jsx(DashboardTooltip, Object.assign({ title: 'Open advanced search', placement: "bottom", arrow: true }, { children: _jsx(ToggleButtonGroup, Object.assign({ color: "primary", value: toggleValue, exclusive: true }, { children: _jsx(CustomToggleButton, Object.assign({ value: "advancedSearch", onClick: openAdvance }, { children: searchStringAdvance !== '' ? (_jsx(AdvanceSearchBlue, { className: iconDeleteStyle })) : (_jsx(AdvanceSearch, { className: iconDeleteStyle })) })) })) })) }))));
        }
        else {
            return (hasSearchString() ? (_jsx(InputAdornment, Object.assign({ position: "end" }, { children: _jsx(IconButton, Object.assign({ className: btnDeleteStyle, onClick: clearSearchString, size: "small", sx: {
                        "& .MuiTouchRipple-root .MuiTouchRipple-child": {
                            borderRadius: "4px",
                            backgroundColor: '#3333331F'
                        }
                    } }, { children: _jsx(CloseIcon, { className: iconDeleteStyle }) })) }))) : (_jsx(_Fragment, {})));
        }
    };
    const disabledInput = showAdvance && searchStringAdvance !== '';
    return (_jsx(LocalizationProvider, Object.assign({ dateAdapter: AdapterDayjs }, { children: _jsxs(AppSearchBar, Object.assign({ ref: objRef, className: !isEmpty(parentStyle) ? parentStyle : classes.parent }, { children: [_jsx(TextField, { size: size, style: {
                        width: width,
                    }, inputProps: {
                        readOnly: disabledInput,
                    }, sx: {
                        '.MuiOutlinedInput-input': {
                            cursor: disabledInput ? 'not-allowed !important' : 'auto !important'
                        },
                    }, placeholder: props.placeHolder || 'Enter keyword...', onChange: handleKeywordChange, onKeyDown: handleKeyPress, value: searchString, InputProps: {
                        startAdornment: (_jsx(InputAdornment, Object.assign({ position: "start" }, { children: _jsx(IconButton, Object.assign({ "aria-label": "search", className: btnSearchStyle, onClick: () => {
                                    if (props.onSearch)
                                        props.onSearch(searchString);
                                }, size: "large" }, { children: _jsx(SearchIcon, { className: iconSearchStyle }) })) }))),
                        endAdornment: (_jsx(_Fragment, { children: EndAdorament() })),
                    } }), _jsx(Popover, Object.assign({ open: displayAdvance, anchorEl: anchorEl, anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    }, transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                    }, onClose: onPopoverClose }, { children: _jsx(Box, Object.assign({ className: classes.advancePopover }, { children: AdvancePopover() })) }))] })) })));
};
export default SearchBar;
